<!--账户信息-->
<template>
  <div class="com-table account border">
    <div class="com-title pr">账户信息</div>
    <div class="account-user">
      <el-upload
        class="avatar-uploader"
        action="/rest/support/editor/kind/files/"
        :http-request="upLoad"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
        <div class="box">
          <template v-if="formLabelAlign.thumbnail !== null
                  && formLabelAlign.thumbnail !== undefined
                  && formLabelAlign.thumbnail !== ''">
            <img :src="formLabelAlign.thumbnail" class="avatar">
          </template>
          <template v-else>
            <img src="../../assets/images/icon_user.png" class="avatar">
          </template>
        </div>
        <span>修改头像</span>
      </el-upload>
    </div>
    <el-form label-width="100px" :model="formLabelAlign">
      <el-form-item label="账户名称：">
        {{formLabelAlign.loginAccount}}
      </el-form-item>
      <!-- <el-form-item label="登录IP：">
        {{formLabelAlign.registerIp}}
      </el-form-item> -->
      <el-form-item label="创建时间：">
        {{formLabelAlign.registerTime}}
      </el-form-item>
      <!-- <el-form-item label="上次登录：">
        {{formLabelAlign.lastLoginTime}}
      </el-form-item> -->
      <el-form-item label="声音提醒：">
        <el-switch v-model="formLabelAlign.whetherVoice" :active-value="0" :inactive-value="1"></el-switch>
      </el-form-item>
      <div class="button">
        <el-button type="primary" @click="submitForm">保存</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
  import Api from '@/api/system/user'
  export default {
    inject: ['reload'],
    name: 'account-info',
    created () {
      this.getInfo()
    },
    data () {
      return {
        formLabelAlign: ''
      }
    },
    methods: {
      getInfo () {
        Api.getInfo(response => {
          let status = response.data.code
          let body = response.data.data || {}
          if (status === '200') {
            this.formLabelAlign = body.info
          }
        })
      },
      handleAvatarSuccess (res, file) {
        this.imageUrl = URL.createObjectURL(file.raw)
      },
      beforeAvatarUpload (file) {
        /* const isJPG = file.type === 'image/jpeg' */
        const isLt2M = file.size / 1024 / 1024 < 2

        /* if (!isJPG) {
         this.$message.error('上传头像图片只能是 JPG 格式!')
         } */
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isLt2M
      },
      submitForm () {
        const form = {
          'headPic': this.formLabelAlign.thumbnail, whetherVoice: this.formLabelAlign.whetherVoice
        }
        Api.updateInfo({form: form}, response => {
          let status = response.status
          const body = response.data
          if (status >= 200 && status <= 204) {
            // let body = this.$store.state.user.info
            // body.info.thumbnail = this.formLabelAlign.thumbnail
            console.log(body)
            this.$store.dispatch('login', {user: body})
            console.log(this.$store.state.user.info)
            this.$message.success('修改成功！')
          } else {
            this.$message.error('修改失败！')
          }
        })
        this.reload()
      },
      upLoad (item) {
        Api.thumbnailUpload({form: {'imgFile': item.file}}, response => {
          if (response !== undefined) {
            let status = response.status || 0
            let body = response.data || []
            if (status >= 200 && status <= 204) {
              if (body.error === 0) {
                this.$set(this.formLabelAlign, 'thumbnail', body.url)
                this.$message.success('略缩图上传成功')
              } else {
                this.$message.error(body.message || '略缩图上传失败')
              }
            } else {
              this.$message.error(body.message || '略缩图上传失败')
            }
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';

  .account {
    .button{
      padding: 33px 0;
      text-align: center;
    }
  }
</style>
<style lang="scss">
  .account {
    .el-input__inner {
      width: 147px;
      height: 32px;
      line-height: 32px;
    }
    .el-form {
      margin-top: 20px;
    }
    .el-form-item {
      border-top: 1px solid #EBEEF5;
      margin: 0;
      padding: 10px 0;
    }
    .avatar-uploader {
      .box {
        width: 50px;
        height: 50px;
        background: #f9f9f9;
        display: inline-block;
        vertical-align: middle;
        border-radius: 50%;
        overflow: hidden;
        margin: 0 18px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      span {
        vertical-align: middle;
        color: #085ECC;
        font-size: 14px;
        margin-left: 10px;
      }
    }
    .el-button--primary{
      background:#085ECC;
      padding: 9px 35px;
      outline: none;
      border: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/AccountInfo.vue